import { getDataSourceByAlias } from '@actions/utils'
import { DATA_PRIMARY_KEY } from './constants'

/**
 * @description: 子/孙表查询、分页加载数据参数构建
 * @param {*} cardStore
 * @param {*} queryRoot
 * @param {*} queryPaging
 * @return {*}
 */
export default function (cardStore, queryRoot, queryPaging) {
  const rootStore = cardStore.rootStore
  // 父ID，查主表、查子表列表时为表单id, 查孙表时为子表行id
  // TODO: billID不一定从pageStore.params.billId取（一个页面多个卡片的场景）
  let parentId = rootStore.pageStore.params.billId
  let matchParent
  const recur = ({ node, parent, depth = 1, parentAlias }) => {
    const { dataSource, paging, filter, alias } = node
    const data = {
      alias: dataSource
    }
    const filterStore = rootStore[filter];
    const pagingStore = rootStore[paging];
    const conditions = filterStore?.getAllCondition()
    const pageInfo = pagingStore?.getPageInfo();
    if (paging) {
      data.needQueryPaging = true
      const page = {
        pageIndex: pageInfo?.pageIndex,
        pageSize: pageInfo?.pageSize,
        totalCount: queryPaging ? -1 : 1
      }
      Object.assign(data, {
        page
      })
    }
    filter && Object.assign(data, {
      extraCondition: conditions
    })
    if (queryRoot.alias === node.alias) {
      parent.main = true
      matchParent = parent
      // 孙表只有选定子表行才能进行后续加载
      if (depth === 3) {
        parentId = rootStore[parentAlias]?.currentActiveRow?.getValue?.(DATA_PRIMARY_KEY)
        if (!parentId) throw new Error('未选定子表行！')
      }
    }
    const children = node.children
    if (children?.length) {
      data.children = []
      children.forEach(child => {
        const childParam =recur({
          node: child,
          parent: data,
          depth: depth + 1,
          parentAlias: alias
        })
        if (
          !queryPaging || childParam.needQueryPaging
        ) {
          data.children.push(childParam)
        }
        if (childParam.needQueryPaging) {
          data.needQueryPaging = true
          delete childParam.needQueryPaging
        }
      })
    }

    addTagDescription({ dataSource, rootStore, data, queryPaging })

    return data
  }
  let data
  try {
    data = recur({ node: { dataSource: cardStore.dataSource, children: cardStore.tableStores } })
  } catch (err) {
    return Promise.reject(err)
  }
  if (!matchParent) {
    matchParent = data
    matchParent.main = true
  }
  const query = {
    id: parentId,
    ...rootStore.pageStore.query,
    billnum: rootStore.pageStore.params.billNo
  }
  if (queryPaging) {
    matchParent.totalCount = true
  }
  // 是存在需要查分页的子节点（如无则无需查询分页信息）
  const needQueryPaging = data.needQueryPaging
  delete data.needQueryPaging
  return { query, data, needQueryPaging }
}

/**
 * @description: 查询卡片拼接多选参照虚拟子实体
 * @return {*}
 */
function addTagDescription ({ dataSource, rootStore, data, queryPaging }) {
  const [relatedDataSource] = getDataSourceByAlias(dataSource, rootStore.dataSource)
  if (relatedDataSource?.children?.length) {
    const tagEntities = relatedDataSource.children.filter(child => child.dataPattern === 'TAG')
    if (
      tagEntities?.length &&
      !queryPaging
    ) {
      if (!data.children) {
        data.children = []
      }
      data.children.push(...tagEntities.map(v => { return { alias: v.alias } }))
    }
  }
}